import classes from "./LoginTypeSwitcher.module.scss";

interface LoginTypeSwitcherProps {
  loginType: string;
  setLoginType: any;
}

export default function LoginTypeSwitcher(props: LoginTypeSwitcherProps) {
  const loginTypes = [
    {
      id: 1,
      type: 'medio',
      title: 'Medio',
    },
    {
      id: 2,
      type: 'medirex',
      title: 'Medirex'
    }
  ]

  return(
    <div className={classes.loginTypeSwitcherContainer}>
      {loginTypes.map((loginType) => (
        <button key={loginType.type} className={[classes.loginTypeButton, props.loginType === loginType.type ? classes.activeLoginTypeButton : ''].join(" ")} onClick={() => props.setLoginType(loginType.type)}>{loginType.title}</button>
      ))}
    </div>
  )
}